import { gql } from "@apollo/client";

export const updateOrganisationSchedule = gql`
  mutation updateOrganisationSchedule($schedule: OrganisationScheduleInput!, $isDelete: Boolean!) {
    organisation_UpdateSchedule(schedule: $schedule, isDelete: $isDelete) {
      _id
      company_policy_nudge_schedules {
        _id
        time
        day
      }
    }
  }
`;

